import { useNavigate } from "react-router-dom";
import ContentPage from "../../Content";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import BaseUrl from "../../../utils/BaseUrl";
import CustomerStyle from "../../../utils/customerStyle";
import DataTable from "react-data-table-component";
import separateNumber from "../../../utils/separateur";
import ExportExcel from "../../../utils/ExcelExport";
import { UserContext } from "../../../utils/User_check";
import can from "../../../utils/Can";
import PageHeader from "../../ui/PageHeader";
import SectionCard from "../../ui/SectionCard";
import SearchBox from "../../ui/SearchBox";
import EmptyState from "../../ui/EmptyState";

const url = BaseUrl();
const customerStyle = CustomerStyle();
function Commerciaux(){
  const [itemsList,setItemsList] = useState([]);
  const [itemsListFilter,setItemsListFilter] = useState([]);
  const [loading, setLoading] = useState(false);


  const columns = [

    {
      name: "NOM ET PRENOMS",
      selector : row =>(
        <div className="d-flex align-items-center py-1">
          <img src="../../../assets/images/faces-clipart/pic-1.png" alt="" className="rounded-circle me-2" style={{width:28,height:28}} />
          <b>{row.NomCommercial}</b>
        </div>
      )
    },

    {
      name: "NUMERO MARCHAND",
      selector : row => row.NumeroMarchand
    },

    {
      name: "TERRITOIRES",
      selector : row => row.NomTerritoire,
    },
    {
      name: "SECTEURS",
      selector : row => row.NomSecteur
    },
    {
      name: "OBJECTIF CASHIN",
      selector : row => <b className="text-danger">{separateNumber(row.ObjectifCashin)}</b>
    },
    {
      name: "OBJECTIF CASHOUT",
      selector : row => <b className="text-danger">{separateNumber(row.ObjectifCashOut)}</b>
    },
    {
      name: "OBJECTIF EVD",
      selector : row => <b className="text-success">{separateNumber(row.ObjectifEvd)}</b>
    },

    // {
    //   name: "STATUT",
    //   selector : row => (
    //     <>
    //      {row.is_active == 1 && (
    //     <span className="badge bg-success">Actif</span>
    //     )}
    //     {row.status == 0 && (
    //         <span className="badge bg-danger">Inactif</span>
    //     )}
    //     </>
    //   )
    // },



];
    const {user,role, permissions} = useContext(UserContext);
    const navigate = useNavigate();
    useEffect(()=>{
      if(user && permissions && !can(permissions,'PAGE LISTE COMMERCIAUX')){
          navigate('/page-no-found');
      }
  },[user]);

  useEffect(()=>{
    fetchItemsList();
  },[]);
  const fetchItemsList = async ()=>{
    setLoading(true);
    try {
        axios.get(url.base+'/commerciaux',{
            headers:{
                'Content-Type':'application/json',
                "Authorization": `Bearer ${localStorage.getItem('_token_')}`

            },
        }).then((resp)=>{

            if(resp.status == 200){
                setItemsList(resp.data);
                setItemsListFilter(resp.data);
            }
            setLoading(false);
        })
    } catch (error) {
        setLoading(false);
    }
}

const handleFilter=(event)=>{
  const datas = itemsListFilter?.filter(row => row.NomCommercial.toLowerCase().includes(event.target.value.toLowerCase() ) || row.NomSecteur.toLowerCase().includes(event.target.value.toLowerCase()) || row.NomTerritoire.toLowerCase().includes(event.target.value.toLowerCase()) || row.NomZone.toLowerCase().includes(event.target.value.toLowerCase()) || row.NumeroMarchand.toLowerCase().includes(event.target.value.toLowerCase()) )  ;
  setItemsList(datas);
}
    return (
        <>
            <ContentPage>
              <PageHeader eyebrow="Ressources humaines" title="Liste des commerciaux" />

              <div className="col-lg-12 grid-margin stretch-card">
                <SectionCard
                  icon="mdi-account-group"
                  color="primary"
                  title="Commerciaux par découpage"
                  actions={
                    <>
                      <SearchBox placeholder="Rechercher un commercial..." onChange={handleFilter} className="me-2" />
                      <ExportExcel excelData={itemsList} filename={"LISTE DES COMMERCIAUX"}  title={"Télécharger"} color={"btn-success"}/>
                    </>
                  }
                >
                    <div className="table-responsive">
                    <DataTable
                          columns={columns}
                          data={itemsList}
                          customStyles={customerStyle}
                          pagination
                          selectableRows
                          striped
                          highlightOnHover
                          progressPending={loading}
                          progressComponent={
                              <div className="text-center py-5">
                                  <div className="spinner-border text-primary" role="status"></div>
                              </div>
                          }
                          noDataComponent={<EmptyState icon="mdi-account-search-outline" title="Aucun commercial trouvé" />}
                      />
                    </div>
                </SectionCard>
              </div>
            </ContentPage>
        </>
    )
}
export default Commerciaux;
